import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HomeApiService } from 'src/app/service/home/home-api.service';
import { DataStoreService } from 'src/app/utils/data_store/data-store.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  private readonly apiService = inject(HomeApiService);
  private readonly dataStore = inject(DataStoreService);
  private readonly destroyRef = inject(DestroyRef);

  // Domain signals
  readonly username = signal<string>('User');
  readonly login_role = signal<string>('');
  readonly smsbalance = signal<number | string>(0);
  readonly isBalanceAccess = signal<boolean>(false);

  ngOnInit(): void {
    this.initializeUserData();
  }

  private initializeUserData(): void {
    this.username.set(this.dataStore.getLoginName() ?? 'User');
    this.login_role.set(this.dataStore.getRole() ?? '');

    const privilegedRoles = ['SUPER_ADMIN', 'ADMIN'];
    const currentRole = this.login_role().toUpperCase();

    if (privilegedRoles.includes(currentRole)) {
      this.isBalanceAccess.set(true);
      this.fetchSmsBalance();
    }
  }

  private fetchSmsBalance(): void {
    this.apiService.getBoomBalance()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (value: any) => {
          const balance = value?.balance ?? value ?? 0;
          this.smsbalance.set(balance);
        },
        error: (err: any) => {
          console.error('Telephony Balance Retrieval Failed:', err);
        }
      });
  }
}
